import React from "react";
import styled from "styled-components";
import Color from "../../../assets/Colors";
import {Main} from "../../../styles/GlobalStyles";
import {Link} from "react-router-dom";
import {ResetButton} from "../../../styles/Button";
import {ReactComponent as CloseIcon} from "../../../assets/icons/close.svg";
import InstaLogo from "../../../assets/icons/insta.png";
import FaceLogo from "../../../assets/icons/face.png";
import Text from "../../../styles/Text";
import useLockBodyScroll from "../../../hooks/useLockBody";

export default function MobileMenu({menuIsOpen, setMenu}) {
   useLockBodyScroll();

   return (
      <Main>
         <Menu isOpen={menuIsOpen}>
            <div className="head">
               <Link className="logo" to="/">
                  <img src={require("../../../assets/logo/domecq_academy_white.png")} alt="domecq" />
               </Link>
               <ButtonAction onClick={() => setMenu(false)}>
                  <CloseIcon width="0.9em" height="0.9em" className="icon" />
               </ButtonAction>
            </div>
            <ul>
               {ListItems.map((item, index) => (
                  <li key={index}>
                     <Link to={item.path} onClick={() => setMenu(false)}>
                        0{index + 1} <span>{item.name}</span>
                     </Link>
                  </li>
               ))}{" "}
                
            </ul>
            <div className="footer">
               <div className="social">
                  <a href="https://www.instagram.com/casapedrodomecq/" target="_blanck">
                     <img src={InstaLogo} alt="ins" />
                  </a>
                  <a href="https://www.facebook.com/casapedrodomecqmx/" target="_blanck">
                     <img src={FaceLogo} alt="fb" />
                  </a>
               </div>
               <Text color="white">
                  El lugar de la experiencia, <br />
                  pasión y conocimiento
               </Text>
            </div>
         </Menu>
      </Main>
   );
}

const ListItems = [
   {name: "Cursos esenciales domecq", path: "/cursos_esenciales"},
   {name: "Certificado prime domecq", path: "/certificado_prime"},
   {name: "Programa emblem domecq", path: "/programa_emblem"},
   {name: "Programa enterprise domecq", path: "/programa_enterprise"},
   {name: "Acerca de domecq academy", path: "/domecq_academy"},
   {name: "Facilitadores y expertos", path: "/facilitadores"},
   {name: "preguntas frecuentes", path: "/preguntas_frecuentes"},
   {name: "Contacto", path: "/contacto"},
];

const Menu = styled.div`
   width: 100%;
   height: 100%;
   background: ${Color.primary};
   position: fixed;
   top: 0;
   left: 0;
   padding: 8vw;

   z-index: 1000;

   opacity: ${props => (props.isOpen ? "1" : "0")};
   transition: opacity 500ms ease;
   z-index: ${props => (props.isOpen ? "1000000" : "-1000000")};
   pointer-events: ${props => (props.isOpen ? "initial" : "none")};

   & ul {
      padding: 0;
      list-style: none;
      margin-top: 1em;
      display: flex;
      flex-direction: column;

      & li {
         margin: 0.5em 0;

         & a {
            font-size: 0.88em;
            color: white;
            font-weight: 200;
            padding: 0.1em 0;
            text-transform: uppercase;

            & span {
               margin-left: 1em;
            }
         }
      }
   }

   & .head {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & button {
         padding: 0 0.3em;
         margin-bottom: -20px;

         &:first-child {
            margin-right: 0.5em;
         }
      }
   }

   & .logo {
      display: block;
      width: 100px;
      // margin-left: -15px;

      & img {
         width: 100%;
      }
   }

   & .footer {
      padding-left: 2.3em;
      margin-top: 2em;
      & .social {
         & a {
            width: 30px;
            display: inline-block;

            &:first-child {
               margin-right: 1em;
            }

            & img {
               object-fit: cover;
               width: 100%;
            }
         }
      }
      & p {
         font-size: 0.88em;
         margin-top: 2em;
      }
   }
`;

const ButtonAction = styled(ResetButton)`
   color: white;
   & .icon {
      fill: white;
   }
`;
